<template>
  <modal :id="name" :name="name" @before-open="beforeOpen" @opened="opened" @before-close="beforeClose" :height="height"
    :delay="200" :width="width" :scrollable="scrollable" :min-height="600" :click-to-close="clickToClose"
    :pivot-y="0.2">
    <div class="modal-content">
      <header v-if="!hideHeader" class="modal-header">
        <slot v-if="hasSlot('title')" name="title"></slot>
        <h5 v-if="!hasSlot('title')" class="modal-title">{{ title }}</h5>
        <button v-if="!hideCloseButton" type="button" aria-label="Close" class="close" @click="$modal.hide(name)">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </header>
      <div class="modal-body" :class="bodyClass">
        <slot v-if="params" :model="model"></slot>
      </div>
      <footer v-if="!hideFooter" class="modal-footer" :class="{ 'alert-footer': isAlert }">
        <div class="control-content">
          <slot name="control"></slot>
        </div>
        <div v-if="!hideFooterButton" class="footer-buttons">
          <button type="button" v-show="cancelText" class="btn btn-outline-secondary btn-sm" @click="onCancel()">{{
            cancelText }}</button>
          <app-btn-submit v-show="okText" :isSubmitting="isSubmitting" :css="okClass" :text="okText"
            @on-click="onOk()" />
        </div>
      </footer>
    </div>
  </modal>
</template>

<script>
import AppBtnSubmit from '@/components/app-button/index';
// import { datadogRum } from '@datadog/browser-rum';

function isVisible(elem) {
  const clientRect = elem.getClientRects && elem.getClientRects().length;
  return !!(elem.offsetWidth || elem.offsetHeight || clientRect);
}

const valuesToLabels = (ctx) => {
  return {
    invoiceType: {
      ALL: `${ctx.$t('app.all')}`,
      PAID: `${ctx.$t('invoice.paid')}`,
      VERIFIED: `${ctx.$t('invoice.verified')}`,
      NOT_VERIFIED: `${ctx.$t('invoice.unconfirmed')}`
    },
    period: {
      QUARTER: ctx.$t('invoice.quarterly'),
      MONTH: ctx.$t('invoice.month')
    },
  }
}

export default {
  name: 'AppModal',
  components: {
    AppBtnSubmit,
  },
  props: {
    title: {
      type: String,
      default() {
        return this.name;
      },
    },
    name: {
      type: String,
    },
    okText: {
      type: String,
      default() {
        return this.$t('app.update');
      },
    },
    okClass: {
      type: String,
      default: 'btn btn-primary btn-sm',
    },
    cancelText: {
      type: String,
      default() {
        return this.$t('app.close');
      },
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    hideFooterButton: {
      type: Boolean,
      default: false,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: null,
    },
    width: {
      type: [String, Number],
      default: '600px',
    },
    height: {
      type: [String, Number],
      default: 'auto',
    },
    minHeight: {
      type: [Number],
      default: 0,
    },
    submitOnEnter: {
      type: Boolean,
      default: true,
    },
    clickToClose: {
      type: Boolean,
      default: false,
    },
    escToClose: {
      type: Boolean,
      default: true,
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
    isAlert: {
      type: Boolean,
      default: false,
    },
    bodyClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      model: null,
      params: null,
      isLoaded: false,
      beforeCloseCb: null,
    };
  },
  methods: {
    hasSlot(slotName = 'default') {
      return !!this.$slots[slotName];
    },
    checkScrollbar() {
      const modalContent = this.$el.querySelector('.modal-body');
      if (modalContent.scrollHeight > modalContent.clientHeight) {
        modalContent.style.setProperty('--padding-right', '0.5rem');
      } else {
        modalContent.style.setProperty('--padding-right', '1.5rem');
      }
    },
    onKeyup(event) {
      if (event.key === 'Escape' && this.escToClose && document.activeElement.type !== 'file') {
        this.onCancel();
        return;
      }
      const ENTER = 13;
      if (!this.submitOnEnter || event.keyCode !== ENTER ||
        !this.params || !this.$options.isVisible(this.$el)) {
        return;
      }
      const params = this.model || null;
      this.$emit('on-ok', params);
    },
    beforeOpen(event) {
      if (!event.params) {
        return;
      }
      this.model = event.params.model;
      this.params = event.params;
      window.addEventListener('keyup', this.onKeyup);
      this.$emit('before-open', this.params);
      const pageCtx = {};
      const actionLabels = valuesToLabels(this)
      Object.entries({ ...this.$route.query, ...this.$route.params }).forEach(([key, value]) => {
        if (actionLabels[key]) {
          pageCtx[key] = actionLabels[key][value]
        }
      });
      // datadogRum.addAction(`Mở modal ${this.title || this.name}`, {
      //   ...pageCtx,
      //   viewName: this.$route.meta.viewName
      // })
    },
    opened() {
      this.checkScrollbar();
      this.$emit('opened', this);
    },
    beforeClose(event) {
      this.$emit('before-close', event);
      window.removeEventListener('keyup', this.onKeyup);
    },
    onOk() {
      setTimeout(() => {
        this.$emit('on-ok', this.model);
      }, 500);
    },
    close() {
      this.$modal.hide(this.name, { isOk: true });
    },
    onCancel() {
      this.$modal.hide(this.name, { isCancel: true });
      this.$emit('on-cancel', this.model);
    },
  },
  isVisible,
};
</script>
<style lang="scss" scoped>
.modal-body {
  padding-right: var(--padding-right, 1.5rem);
}
</style>



// WEBPACK FOOTER //
// src/components/app-modal/index.vue